import {isTrue} from "../../libs/utils/epic.utils";

export class NotificationDto {

  public readonly id!: string;
  public readonly level!: string;
  public readonly type!: string;
  public readonly message!: string;
  public readonly timeversion!: Date;
  public /* readonly */ read: boolean | undefined;

  constructor(init?: Partial<NotificationDto>) {
    Object.assign(this, init);
    if (init?.timeversion) {
      this.timeversion = new Date(init.timeversion);
    }
  }

  public hasTranslation(): boolean {
    return this.message.startsWith('notification.');
  }

  public isNew(): boolean {
    return this.read === undefined || !this.read;
  }

  public isWarning(): boolean {
    return this.level === 'WARNING';
  }

  public isRead(): boolean {
    return isTrue(this.read);
  }

  public notRead(): boolean {
    return !this.isRead();
  }
}
